import { CdkCell, CdkCellDef, CdkColumnDef, CdkHeaderCell, CdkHeaderCellDef } from '@angular/cdk/table';
import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SparePart, SparePartGroup } from '@ecs-features/result/spare-parts-result/spare-parts.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseTableComponent, BaseTableModule, SelectableRow } from '@os-components';
import { SewTableInput } from '@sew/ui-components-angular/standalone';
import { PartDetail } from 'src/app/components/part-table/part-table.interface';
import { RecommendedPart } from '../../parts-recommendation.interface';

@Component({
    selector: 'ecs-parts-recommendation-table',
    templateUrl: './parts-recommendation-table.component.html',
    styleUrls: ['./parts-recommendation-table.component.scss'],
    imports: [
        BaseTableModule,
        CdkColumnDef,
        CdkHeaderCellDef,
        CdkHeaderCell,
        CdkCellDef,
        CdkCell,
        TranslatePipe,
        SewTableInput,
    ],
})
export class PartsRecommendationTableComponent implements AfterViewInit {
    @Input() public set items(value: SelectableRow<RecommendedPart>[]) {
        // #20231212-1358 previously displayed (but not selected) recommendations are also added
        // when adding another parts recommendations
        this.table?.unselectAllChecked();
        this._items = value;
        this.toggleAllRowsChecked();
    }

    @Input() public columns: string[] | null = null;
    @Input() public hideMarkedBar = false;
    @Input() public showCheckboxColumn = true;

    @Output() public rowSelect = new EventEmitter<SelectableRow<RecommendedPart>[]>();

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public _items: SelectableRow<RecommendedPart>[] = [];

    @ViewChild(BaseTableComponent) private table?: BaseTableComponent<SparePart, SparePartGroup, PartDetail>;

    public onRowSelect(event: SelectableRow<RecommendedPart>[]) {
        this.rowSelect.emit(event);
    }

    public ngAfterViewInit() {
        this.toggleAllRowsChecked();
    }

    public toggleAllRowsChecked() {
        // prevent NG0100: Expression has changed after it was checked
        // https://blog.angular-university.io/angular-debugging/
        setTimeout(() => {
            this.table?.toggleAllChecked(true);
        });
    }
}
